// LUMINA · pages/vajra/components/EnergyDharmaWidget.jsx
// Phase 39D: extracted from VajraPortal.jsx

import React, { useState } from 'react';
import { GD, DG, ELEMENT_PRACTICES } from '../constants';

export default function EnergyDharmaWidget({ member }) {
  const [expanded, setExpanded] = useState(false);
  return (
    <div style={{background:`linear-gradient(135deg,rgba(107,26,26,0.06),rgba(184,134,11,0.06))`,border:`1px solid rgba(184,134,11,0.2)`,borderRadius:12,padding:"16px 18px",marginBottom:20}}>
      <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer"}} onClick={()=>setExpanded(!expanded)}>
        <div>
          <div style={{fontSize:13,color:GD,letterSpacing:.5}}>☸ 能量与实修对治</div>
          <div style={{fontSize:11,color:"#bbb",marginTop:2}}>五大元素 · 修持法门对应</div>
        </div>
        <span style={{color:GD,fontSize:14}}>{expanded?"▲":"▼"}</span>
      </div>
      {expanded && (
        <div style={{marginTop:16,paddingTop:16,borderTop:`1px solid rgba(184,134,11,0.12)`}}>
          {member?.has_energy_profile ? (
            <div style={{fontSize:13,color:DG,padding:"10px 14px",
              background:"rgba(6,78,59,0.06)",borderRadius:8,marginBottom:12}}>
              ✓ 已启用个性化对治 — 修持建议将根据您的修行次第自动调整
            </div>
          ) : null}
          <div style={{fontSize:12,color:"#aaa",letterSpacing:1,textTransform:"uppercase",marginBottom:10}}>五大元素修持参考</div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
            {Object.entries(ELEMENT_PRACTICES).map(([key,val])=>(
              <div key={key} style={{background:val.bg,border:`1px solid ${val.color}22`,borderRadius:8,padding:"10px 12px"}}>
                <div style={{fontSize:12,color:val.color,marginBottom:6,fontWeight:"bold"}}>{key}</div>
                {val.practices.map(p=>(
                  <div key={p} style={{fontSize:11,color:"#666",marginBottom:2}}>· {p}</div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
